/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {Checkbox, Stack} from '@salesforce/retail-react-app/app/components/shared/ui'
import {
    ADD_FILTER,
    REMOVE_FILTER
} from '@salesforce/retail-react-app/app/pages/product-list/partials/refinements-utils'

const CheckboxRefinements = ({filter, toggleFilter, selectedFilters}) => {
    const {formatMessage} = useIntl()
    return (
        <Stack
            spacing="20px"
            margin={{lg: '10px', base: '20px 10px 0 10px'}}
            maxHeight="300px"
            overflowY="auto"
            sx={{
                overflowX: 'auto',
                whiteSpace: 'nowrap',
                '&::-webkit-scrollbar': {
                    width: '4px'
                },
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'gray.800',
                    borderRadius: '2px',
                    width: '4px',
                    display: 'block'
                },
                '&::-webkit-scrollbar-track': {
                    backgroundColor: 'gray.400',
                    borderRadius: '2px',
                    width: '4px',
                    display: 'block'
                },
                userSelect: 'none',
                scrollBehavior: 'smooth'
            }}
        >
            {filter.values?.map((value) => {
                const isChecked = selectedFilters.includes(value.value)
                // Don't display refinements with no results, unless we got there by selecting too
                // many refinements
                if (value.hitCount === 0 && !isChecked) return

                return (
                    <Checkbox
                        isChecked={isChecked}
                        key={value.value}
                        onChange={() => {
                            toggleFilter(value, filter.attributeId, isChecked)
                        }}
                        aria-label={formatMessage(isChecked ? REMOVE_FILTER : ADD_FILTER, value)}
                        color="black"
                        fontWeight="300"
                        name={value.label}
                    >
                        {value.label}
                    </Checkbox>
                )
            })}
        </Stack>
    )
}

CheckboxRefinements.propTypes = {
    filter: PropTypes.object,
    toggleFilter: PropTypes.func,
    selectedFilters: PropTypes.array
}

export default React.memo(CheckboxRefinements)
